import { Typography } from "@mui/material";
import pako from "pako";

export const decompress = (message) => {
  if (
    message["py/object"] ===
    "st_service_common_lib.codecs.codec.python_compression_codec.CompressedObject"
  ) {
    const decodedData = atob(message["data"]);
    const byteArray = Uint8Array.from(decodedData, (char) =>
      char.charCodeAt(0)
    );
    const inflatedData = pako.inflate(byteArray, { to: "string" });
    return JSON.parse(inflatedData);
  } else {
    return message;
  }
};

export const isHumanText = (message) => {
  return (
    message["py/object"] === "st_storytelling_core_lib.types.chat.HumanText"
  );
};

export const isChatMetaData = (message) => {
  return (
    message["py/object"] ===
    "st_smith_backend_common_lib.types.chat.ChatMetadata"
  );
};

export const isRouter = (message) => {
  return message["py/object"] === "st_storytelling_core_lib.types.chat.Route";
};

export const isVideoClip = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.BBVideoStoryClip"
  );
};

export const isVoiceOverVideoClip = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.VoiceoverBBVideoClip"
  );
};

export const isAlternateClip = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.BBAlternateClip"
  );
};

export const isRelated = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.VideoStoryHeader"
  );
};

export const isStoryMetadata = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.VideoStoryMetadata"
  );
};

export const isStoryline = (message) => {
  return (
    message["py/object"] === "st_storytelling_core_lib.types.chat.BBStoryline"
  );
};

export const isAnswer = (message) => {
  return (
    message["py/object"] === "st_storytelling_core_lib.types.chat.BBAgentAnswer"
  );
};

export const isAgentText = (message) => {
  return (
    message["py/object"] === "st_storytelling_core_lib.types.chat.AgentText"
  );
};

export const isComplete = (message) => {
  return (
    message["py/object"] ===
      "st_storytelling_core_lib.types.chat.CompletionToken" &&
    message["status"]["name"] === "COMPLETE"
  );
};

export const isOsDebugContext = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.OpenSearchDebugContext"
  );
};

export const isLlmCallContext = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.LLMCallContext"
  );
};

export const isHCLiveStreamClip = (message) => {
  return (
    message["py/object"] ===
    "st_storytelling_core_lib.types.chat.HCLiveStreamClip"
  );
};

const defaultErrorMessage = "Oops, something went wrong. Please try again.";

export const getErrorMessage = (message) => {
  let errorMessage = "";
  if (message["message"] === "Internal server error") {
    errorMessage = defaultErrorMessage;
  } else if (
    message["py/object"] ===
      "st_storytelling_core_lib.types.chat.CompletionToken" &&
    message["status"]["name"] === "ERROR"
  ) {
    errorMessage = message["error_msg"];
  }
  return errorMessage;
};

export const generateDebugDrawerContent = (debugMessages) => {
  // console.log('generateDebugDrawerContent: ', debugMessages)
  return debugMessages.map((message) => {
    if (isOsDebugContext(message)) {
      const metadata = JSON.stringify(message["metadata"], null, 2);
      const metadataWithLink = metadata.replace(
        /"shot_document_id": "(.*?)"/g,
        `"shot_document_id": "<a href='http://shorttok-dev-lb-1259548594.us-west-1.elb.amazonaws.com/coresvc/coresvc/admin/opensearch/bloomberg-shots-v2/$1' target='_blank' rel='noopener noreferrer'>$1</a>"`
      );

      return (
        <>
          <Typography
            component="pre"
            sx={{
              margin: 1,
              fontSize: 12,
              fontFamily: "monospace",
              borderRadius: "4px",
              background:
                sessionStorage.getItem("mode") === "light"
                  ? "#efefef"
                  : "#000000",
              padding: 1,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowY: "auto",
              height: "40vh",
            }}
          >
            {`Start Time: ${new Date(
              message["start_time"]["epoch_millis"]
            ).toLocaleString("en-US", {
              timeZone: "America/New_York",
            })} ET\nEnd time: ${new Date(
              message["end_time"]["epoch_millis"]
            ).toLocaleString("en-US", {
              timeZone: "America/New_York",
            })} ET\nMetadata: `}
            <span dangerouslySetInnerHTML={{ __html: metadataWithLink }} />
          </Typography>
        </>
      );
    } else if (isLlmCallContext(message)) {
      return (
        <Typography
          component="pre"
          sx={{
            margin: 1,
            fontSize: 12,
            fontFamily: "monospace",
            borderRadius: "4px",
            background:
              sessionStorage.getItem("mode") === "light"
                ? "#efefef"
                : "#000000",
            padding: 1,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowY: "auto",
            height: "40vh",
          }}
        >
          {`Name: ${message["name"]}\nModel: ${
            message["model"]
          }\nOutput:\n${JSON.stringify(message["output"], null, 2)}\nPrompt:\n${
            message["prompt"]
          }`}
        </Typography>
      );
    }
  });
};
